import { defineMessages } from "react-intl";

export const messages = defineMessages({
  "id": {
    id: "deleted_entity_table_column_id",
    defaultMessage: "Id"
  },
  "name": {
    id: "deleted_entity_table_column_name",
    defaultMessage: "Název"
  },
  "description": {
    id: "deleted_entity_table_column_description",
    defaultMessage: "Stručná charakteristika"
  },
  "extSystem": {
    id: "deleted_entity_table_column_extSystem",
    defaultMessage: "Ext. systém"
  },
  "deleteDate": {
    id: "deleted_entity_table_column_deleteDate",
    defaultMessage: "Datum smazání"
  },
  "replacedBy": {
    id: "deleted_entity_table_column_replacedBy",
    defaultMessage: "Nahrazující entita"
  }
})
